// extracted by mini-css-extract-plugin
export default {"Product":"Product_Product__n1-iM"};